import { FieldBase } from '@/components/form';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Standort } from '@/domain/mitarbeiter/features/anlageassistent/entities/Standort';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function TarifgruppeSelect({ standort }: { standort: Standort }) {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <form.AppField
      name="bezahlung.bezahlungsart.tarifGruppe"
      listeners={{
        onChange: ({ value }) => {
          const selectedTarifgruppe = standort.tarifvertrag?.tarifgruppen.find(
            (tg) => tg.id.toString() === value,
          );
          if (selectedTarifgruppe) {
            form.setFieldValue(
              'bezahlung.bezahlungsart.stundenlohn',
              selectedTarifgruppe?.stundenlohn.toLocaleString('de-DE', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              }),
            );
            form.setFieldValue(
              'bezahlung.bezahlungsart.monatsgehalt',
              selectedTarifgruppe?.gehalt.toLocaleString('de-DE', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              }),
            );
          } else {
            ctx.resetDependentFields('bezahlung.bezahlungsart.tarifGruppe');
          }
        },
      }}>
      {(field) => (
        <FieldBase
          isRequired
          label={t(
            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.label',
          )}>
          <Select
            value={(field.state.value as string | null) ?? undefined}
            onValueChange={field.handleChange}>
            <SelectTrigger>
              <SelectValue
                onBlur={field.handleBlur}
                placeholder={t(
                  'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.placeholder',
                )}
              />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="keine">
                {t(
                  'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.keineTarifgruppe',
                )}
              </SelectItem>
              {standort.tarifvertrag?.tarifgruppen.map((tarifgruppe) => (
                <SelectItem key={tarifgruppe.id} value={tarifgruppe.id}>
                  {`${t(
                    'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.tarifgruppe.prefix',
                  )} ${tarifgruppe.gruppe}`}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FieldBase>
      )}
    </form.AppField>
  );
}
